import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { EErrorType, TErrorMessageMapper } from './error-page.model';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false,
})
export class ErrorPageComponent implements OnInit {
  public errorMessage: string = '';

  private errorMessageMapper: TErrorMessageMapper = {
    [EErrorType.FILE_EXPIRED]: {
      message: 'error.fileExpired',
    },
  };

  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
  ) {}

  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const errorType: EErrorType = params['type'] || EErrorType.FILE_EXPIRED;
      this.errorMessage = this.errorMessageMapper[errorType].message;
    });
  }
}
